import { ApiClientError } from "../api/errors.js";
import type { AccessibleError } from "./types.js";

export function isNetworkError(error: unknown): boolean {
  if (error instanceof ApiClientError) {
    return error.code === "network_error" || error.statusCode === 0;
  }
  if (error instanceof TypeError) {
    const msg = error.message.toLowerCase();
    return msg.includes("fetch") || msg.includes("network") || msg.includes("failed");
  }
  if (error instanceof Error) {
    const msg = error.message.toLowerCase();
    return msg.includes("network") || msg.includes("offline") || msg.includes("failed to fetch");
  }
  return false;
}

export function toAccessibleError(
  error: unknown,
  fallbackMessage = "Неизвестная ошибка",
): AccessibleError {
  if (error instanceof ApiClientError) {
    const retryable =
      error.statusCode === 0 ||
      error.statusCode >= 500 ||
      error.code === "network_error" ||
      error.code === "http_error";
    return {
      id: `err-${error.correlationId || Date.now()}`,
      message: error.message || fallbackMessage,
      code: error.code,
      retryable,
      ...(error.correlationId ? { correlationId: error.correlationId } : {}),
    };
  }
  if (isNetworkError(error)) {
    return {
      id: `err-${Date.now()}`,
      message: "Нет связи с сервером. Проверьте сеть и повторите.",
      code: "network_error",
      retryable: true,
    };
  }
  if (error instanceof Error) {
    return {
      id: `err-${Date.now()}`,
      message: error.message || fallbackMessage,
      code: "client_error",
      retryable: false,
    };
  }
  return {
    id: `err-${Date.now()}`,
    message: fallbackMessage,
    code: "unknown",
    retryable: false,
  };
}
